const initialState = {
    list: {},
    error: {}
}

const TimeZoneReducer = (state, action) => {
    if (state === null || state === undefined) {
        state = initialState;
    }

    switch (action.type) {
        case "FETCH_ALL_TIMEZONES_SUCCESS":
            state = {
                ...state,
                list: action.payload
            };
            return state;
        case "FETCH_ALL_TIMEZONES_ERROR":
            state = {
                ...state,
                error: action.payload
            };
            return state;
        case "PURGE_STORE":
            return {};
        default:
            return state;
    }
};

export default TimeZoneReducer;
